import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960.18174 0.0116972603L451 509.193437 533.69963 592.01004 901.812411 223.897259 901.812411 1696.11444 533.69963 1328.11863 451 1410.81826 960.18174 1920 1469.36348 1410.81826 1386.78082 1328.11863 1018.66804 1696.11444 1018.66804 223.897259 1386.78082 592.01004 1469.36348 509.193437z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExpandItemsLine = /*#__PURE__*/function (_Component) {
  _inherits(IconExpandItemsLine, _Component);

  var _super = _createSuper(IconExpandItemsLine);

  function IconExpandItemsLine() {
    _classCallCheck(this, IconExpandItemsLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconExpandItemsLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExpandItems",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconExpandItemsLine.displayName = "IconExpandItemsLine";
  return IconExpandItemsLine;
}(Component);

IconExpandItemsLine.glyphName = 'expand-items';
IconExpandItemsLine.variant = 'Line';
IconExpandItemsLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExpandItemsLine;
export { IconExpandItemsLine };